import { Helper } from '../../Helper';
export class CreateArrayHelper extends Helper {
    emit(sb, node, options) {
        if (options.pushValue) {
            sb.emitPushInt(node, 0);
            sb.emitOp(node, 'NEWARRAY');
            sb.emitHelper(node, options, sb.helpers.wrapArray);
        }
    }
}

//# sourceMappingURL=CreateArrayHelper.js.map
